import React, { useContext, useEffect, useState } from "react";

import tokenStorageService from "../services/TokenStorageService";
import { getOrgShortName } from "../services/authservice";
import useAuth from "../hooks/useAuth";

import { AppContext } from "../application/AppContext";
import { cleanupLocalStorageAuthValues } from "../utility/auth";

const HandleOAuthCallback = () => {
  const { handleAttemptedNavigation } = useContext(AppContext);
  const { setAuthFromLocalStorage } = useAuth();
  const [isLoading, setLoading] = useState<boolean>(true);

  function getQueryParam(name: string) {
    if (window.location.href.includes(name)) {
      return window.location.href.split(`${name}=`)[1].split("&")[0];
    }
    return "";
  }

  //External Provider will add the token and userId to the query param,
  //extract these and store in local storage
  //when a token is set, the user will be redirected
  useEffect(() => {
    // clean up stuffs from last login
    cleanupLocalStorageAuthValues();

    tokenStorageService.setItem("userId", getQueryParam("user_id"));
    tokenStorageService.setItem("token", getQueryParam("access_token"));
    setAuthFromLocalStorage()
    setLoading(false);
  }, []);

  //once the token is set, we can extract the orgname to
  //carry out login navigation logic
  useEffect(() => {
    if (!isLoading) {
      const token = getQueryParam("access_token");
      if (token) {
        tokenStorageService.setItem("orgShortName", getOrgShortName());
        const returnPath = getQueryParam("returnPath");
        handleAttemptedNavigation(returnPath);
      }
    }
  }, [isLoading]);

  return <></>;
};

export default HandleOAuthCallback;
